import {Component} from '@angular/core';
import {LanguageService} from '../../../shared/services/language.service';

@Component({
    selector: 'course-reset-instructor-password-support-article',
    template: `
        <ng-container i18n="@@support.articles.resetInstructorPassword">
            <ol>
                <li>
                    <span>Go to the <a routerLink="/organization/instructors">Instructors Overview</a>.</span>
                </li>
                <li>
                    <span>Find the instructor in the list or use the search field to find the instructor.</span>
                </li>
                <li>
                    <span>
                        Click on the three dots on the right side of the instructor.
                        <br />
                        <img src="assets/images/support/{{ languageService.getActiveLanguageCode() }}/resetInstructorPasswordBtn.png" />
                    </span>
                </li>
                <li>
                    <span>
                        Click <strong>Reset password</strong> in the menu that opens.
                    </span>
                </li>
                <li>
                    <span>
                        The new password will be sent to the instructor's e-mail address.<br />
                        Didn't receive the e-mail? Check if the email ended up in the spam box!
                    </span>
                </li>
            </ol>
        </ng-container>
    `
})
export class ResetInstructorPasswordSupportArticleComponent {
    constructor(
        public languageService: LanguageService
    ) {}
}
